module.exports = __webpack_public_path__ + "static/img/produce-tp.97be8aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/taxcellent/produce-tp.png
// module id = W6rw
// module chunks = 34